import * as React from 'react';
import type { TrainingLink } from '@/types/echo_creation';
import { LinkListItem } from './LinkListItem';

interface LinkDisplayListProps {
  links: TrainingLink[];
  onDelete: (id: string) => void;
}

export const LinkDisplayList: React.FC<LinkDisplayListProps> = ({ links, onDelete }) => {
  if (links.length === 0) {
    return (
      <div className='mb-12 w-full'>
        <p className='font-sans text-16 font-normal leading-27 text-gray-450'>
          No links have been uploaded
        </p>
      </div>
    );
  }

  return (
    <div className='mb-12 grid w-full grid-cols-1 gap-4 lg:grid-cols-2'>
      {links.map((link) => (
        <LinkListItem key={link.id} link={link} onDelete={onDelete} />
      ))}
    </div>
  );
};
